import { Dimensions, Platform, StyleSheet } from 'react-native'

export default StyleSheet.create({
  horizontalStepperStyle: theme => ({
    marginBottom: 20,
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 8 : 30,
    paddingTop: 20,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  stepsContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  stepContainerStyle: {
    flexDirection: 'column',
  },
  titlesContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
})
